// LIBRERIE
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";


const Presentation: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section id="presentation" className="text-center space-ptb">
            <div className="container">
                <h1 className="mb-4">{t('homePage.presentation.presentationTitle')}</h1>
                <div className="row">
                    <div className="col-12">
                        <p className="mb-3" dangerouslySetInnerHTML={{ __html: t('homePage.presentation.text1') as string }}></p>
                        <p className="mb-3" dangerouslySetInnerHTML={{ __html: t('homePage.presentation.text2') as string }}></p>
                        <p className="mb-3" dangerouslySetInnerHTML={{ __html: t('homePage.presentation.text3') as string }}></p>
                        <Link to={'/chi-siamo'} className="btn btn-primary text-uppercase">
                            {t('homePage.presentation.btnText')}
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Presentation;